import dayjs from "dayjs";

/**
 * Function will return the current date and time formatted for display on error pages, including the
 * short timezone abbreviation (e.g. "01/01/2026 12:52:23 GMT").
 */
export const formatErrorTimestamp = (): string => {
    const timezone = new Intl.DateTimeFormat("en-GB", {timeZoneName: "short"})
        .formatToParts(new Date())
        .find(part => part.type === "timeZoneName")?.value ?? ""
    return `${dayjs().format("DD/MM/YYYY HH:mm:ss")} ${timezone}`
}
